import React, { useEffect, useState } from "react";
import "./Edit.css";
import { MdClose } from "react-icons/md";
import CkDictionaryDs from "../../DataServices/CkDictionaryDs";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import { insertLog } from "../Logs/InsertLog";

const ViewCk_Dictionary = ({ ck_dictionaryid, closeModal }) => {
    const [viewObject, setViewObject] = useState({});
    const [copyObject, setCopyObject] = useState({});
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];
    const { stopHudRotation, hud, showToast, showAlert } = useCustomContext();
    const ckDictionaryDs = new CkDictionaryDs();
    const [openModal, setOpenModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [jsonText, setJsonText] = useState("");
    const [jsonError, setJsonError] = useState("");
    const [mongoId, setMongoId] = useState("");

    useEffect(() => {
        if (ck_dictionaryid) {
            fetchCkDictionaryById();
        }
    }, [ck_dictionaryid]);

    useEffect(() => {
        if (Object.keys(viewObject).length !== 0) {
            setOpenModal(true)
        }
    }, [viewObject])

    const fetchCkDictionaryById = async () => {
        hud("Please wait...");
        try {
            if (!ck_dictionaryid) {
                return;
            }

            const requestData = {
                ck_dictionary_id: ck_dictionaryid,
            };

            const response =
                await ckDictionaryDs.CK_Dictionary_Object_By_ID_GET(requestData);

            const data = response.data;
            const body =
                typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            if (data.statusCode === 200 && body?.data) {
                const { _id,ck_dictionary_id,createdAt,updatedAt, created_by_email_id, updated_by_email_id, ...rest } = body.data;
                setMongoId(_id);     
                setViewObject(rest);
                setCopyObject(JSON.parse(JSON.stringify(rest)));
                setJsonText(JSON.stringify(rest, null, 2));
            } else {

            }
        } catch (err) {
            insertLog(
              `${userName} failed to fetch CK Dictionary with id: ${ck_dictionaryid}`,
              0,
              useremail,
              hud,
              stopHudRotation,
              showAlert,
              ck_dictionaryid,
              'GET',
              'CK_Dictionary_Object_By_ID_GET',
              'FAILED',
              err.message
            );
            alert(
                err.message || "Something went wrong while fetching CK Dictionary."
            );

        } finally {
            stopHudRotation()

        }
    };

    const handleEnableEdit = () => {
        setJsonText(getDisplayJson(viewObject));
        setIsEditing(true);
    };

    const handleJsonChange = (e) => {
        let value = e.target.value;
    
        const sanitizedValue = value.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "");
        setJsonText(sanitizedValue);
    
        try {
            const parsed = JSON.parse(sanitizedValue);
    
            const { created_by_email_id, updated_by_email_id, _id, ...cleaned } = parsed; // ✅ REMOVE
    
            setViewObject(cleaned);
    
            setJsonError("");
        } catch {
            setJsonError("Invalid JSON format");
        }
    };

    const getDisplayJson = (obj) => {
        if (!obj) return "";
        return JSON.stringify(obj, null, 2);
    };

    const handleCancelEdit = () => {
        setViewObject(copyObject);
        setJsonText(JSON.stringify(copyObject, null, 2));
        setIsEditing(false);
        setJsonError("");
    };

    const deepEqual = (a, b) => {
        try {
            return JSON.stringify(a) === JSON.stringify(b);
        } catch {
            return false;
        }
    };



    const handleUpdate = async () => {
        const isSame = deepEqual(copyObject, viewObject);

        console.log(isSame, "same");
        if (isSame) {
            // closeModal();
            showAlert("No changes have been identified..", [
                {
                    label: "Ok",
                    color: "var(--buttonColor)",
                    onClick: () => { }
                }
            ]);
            return;
        }

        if (jsonError) {
            showAlert("Please fix JSON errors before saving.", [
                { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
            ]);
            return;
        }


        else {
            try {
                hud("Please wait...");

                const payload = {
                    _id: mongoId, ...viewObject, updated_by_email_id: useremail
                };

                const response = await ckDictionaryDs.CK_Dictionary_Update({
                    ck_dictionary_object: payload
                });

                const data = response?.data;
                const body = typeof data?.body === "string" ? JSON.parse(data.body) : data?.body;

                if (data?.statusCode === 200) {
                    showToast({ message: "CK Dictionary updated successfully" });
                    insertLog(
                        `${userName} updated the Ck Dictionary with id:${ck_dictionaryid}`,
                        0,
                        useremail,
                        hud,
                        stopHudRotation,
                        showAlert,
                        ck_dictionaryid,
                        'UPDATE',
                        'CK_Dictionary_Update',
                        'SUCCESS',
                        ''
                      );
                    closeModal(true);
                } else {
                    showAlert(body?.error || "Failed to update CK Dictionary", [
                        { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                    ]);
                }
            } catch (error) {
                insertLog(
                  `${userName} failed to update CK Dictionary with id:${ck_dictionaryid}`,
                  0,
                  useremail,
                  hud,
                  stopHudRotation,
                  showAlert,
                  ck_dictionaryid,
                  'UPDATE',
                  'CK_Dictionary_Update',
                  'FAILED',
                  error.error || error.message
                );
                showAlert(error.error || "Error while updating CK Dictionary", [
                    { label: "Ok", color: "var(--buttonColor)", onClick: () => { } }
                ]);
            } finally {
                stopHudRotation();
            }
        }
    };

    const downloadJSON = () => {
        console.log("View Object:", JSON.stringify(viewObject, null, 2));
        console.log("ck_dictionaryid:", ck_dictionaryid, "typeof:", typeof ck_dictionaryid);

        const safeFilename = (val) =>
            (val === null || val === undefined) ? null :
                String(val).trim().replace(/\s+/g, "_").replace(/[^\w\-_.]/g, "");

        const filename =
            (safeFilename(ck_dictionaryid) && `${safeFilename(ck_dictionaryid)}.json`) ||
            (safeFilename(viewObject?.ck_dictionary_id) && `${safeFilename(viewObject.ck_dictionary_id)}.json`) ||
            "ck_dictionary.json";

        const blob = new Blob([JSON.stringify(viewObject, null, 2)], {
            type: "application/json"
        });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.style.display = "none";

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);

        insertLog(
            `${userName} downloaded the Ck Dictionary with id:${ck_dictionaryid}`,
            0,
            useremail,
            hud,
            stopHudRotation,
            showAlert,
            ck_dictionaryid,
            'GET',
            'CK_Dictionary_Download',
            'SUCCESS',
            ''
          );
    };



    const hasUnsavedChanges = () => {
        return JSON.stringify(copyObject) !== JSON.stringify(viewObject);
    };

    return (
        <>
            {openModal && <div className="edit-modal-backdrop">
                <div className="edit-modal">
                    <div className="edit-modal-header">
                        <span>Generated CK_Dictionary JSON</span>
                        <div className="json-actions-dict">
                            {!isEditing ? (
                                <>
                                    <button className="json-dw-dict" onClick={downloadJSON}>
                                        Download
                                    </button>
                                    <button className="json-ed-dict" onClick={handleEnableEdit}>
                                        Edit
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button className="json-dw-dict" onClick={downloadJSON}>
                                        Download
                                    </button>

                                    <button className="json-ed-dict" style={{ cursor: jsonError ? 'not-allowed' : 'pointer' }} onClick={() => {
                                        if (!jsonError) {
                                            handleUpdate();
                                        }
                                    }}>
                                        Update
                                    </button>
                                </>
                            )}

                            <button
                                className="edit-modal-close"
                                onClick={() => {
                                    if (hasUnsavedChanges()) {
                                        showAlert("You have unsaved changes. Are you sure you want to leave?", [
                                            {
                                                label: "Cancel",
                                                color: "#999",
                                                onClick: () => { }
                                            },
                                            {
                                                label: "Leave",
                                                color: "var(--buttonColor)",
                                                onClick: () => {
                                                    closeModal();
                                                    setViewObject({});
                                                }
                                            }

                                        ]);
                                    } else {
                                        closeModal();
                                        setViewObject({});
                                    }
                                }}
                            >
                                <MdClose size={20} />
                            </button>
                        </div>
                    </div>

                    <div className="edit-modal-body">
                        <div className="json-editor-container-dict">
                            {isEditing && (
                                <MdClose
                                    size={20}
                                    className="json-cancel-inside-dict"
                                    onClick={handleCancelEdit}
                                />
                            )}

                            {!isEditing && (
                                <pre className="edit-json-preview">
                                    {getDisplayJson(viewObject)}
                                </pre>
                            )}
                            {isEditing && (
                                <textarea
                                    className="json-editor-dict"
                                    value={jsonText}
                                    onChange={handleJsonChange}
                                />
                            )}
                        </div>

                        {jsonError && (
                            <p className="error-text" style={{ color: 'red', marginTop: '10px', marginLeft: '5px' }}>
                                {jsonError}
                            </p>
                        )}
                    </div>
                </div>
            </div>}
        </>
    )
}

export default ViewCk_Dictionary;